/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionsplacepicker2Inputs */

const en_actionsplacepicker2 = /** @type {(inputs: Actionsplacepicker2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place`)
};

const de_actionsplacepicker2 = /** @type {(inputs: Actionsplacepicker2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Place" |
*
* @param {Actionsplacepicker2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionsplacepicker2 = /** @type {((inputs?: Actionsplacepicker2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionsplacepicker2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionsplacepicker2(inputs)
	return de_actionsplacepicker2(inputs)
});
export { actionsplacepicker2 as "actionsPlacePicker" }